export default "__VITE_ASSET__DX$CYqAN__"